import React, { useContext, useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout/MainLayout";
import { DataContext } from "../../context/DataContext";
import { getNameInitials } from "../../utils";
const { v4: uuidv4 } = require("uuid");

const SuscripccionComponent = () => {
  const [sessionId, setSessionId] = useState("");
  const [userInfo, setUserInfo] = useState({});
  const [userInitials, setUserInitials] = useState("");
  const { userData } = useContext(DataContext);

  useEffect(() => {
    if (userData?.attributes) {
      const { attributes } = userData;
      setUserInfo(attributes);
      setUserInitials(getNameInitials(attributes.name || attributes.email || ""));
    }
    setSessionId(uuidv4());
  }, [userData]);

  return (
    <MainLayout>
      <div className="flex flex-col" style={{ minHeight: "calc(100vh - 74px)" }}>
        <main className="flex-1 p-6 md:p-8 bg-gray-50 space-y-6 overflow-y-auto">
          <h1 className="text-2xl font-bold">Suscripciones</h1>
          <p className="text-sm text-gray-600">Compra una suscripción y recibe seguimiento personalizado.</p>

          <div className="bg-white rounded-2xl border border-gray-200 p-4 md:p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-lg font-semibold overflow-hidden">
                {userInfo.picture ? (
                  <img src={userInfo.picture} alt={userInfo.name} className="w-full h-full object-cover" />
                ) : (
                  userInitials || "U"
                )}
              </div>
              <div>
                <p className="font-semibold text-gray-900">{userInfo.name || "Usuario"}</p>
                <p className="text-xs text-gray-500">{userInfo.email || ""}</p>
              </div>
            </div>

            <div className="rounded-xl border border-dashed border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
              Sesión: {sessionId}
            </div>

            <div className="mt-4 text-sm text-gray-700">
              <p>Próximamente: planes de seguimiento, pago seguro y beneficios exclusivos.</p>
            </div>
          </div>
        </main>
      </div>
    </MainLayout>
  );
};

export default SuscripccionComponent;
